<template>
  <div class="main_wrapper">
    <img src="/Kasiwabara-logo.png" v-if="$route.path != '/printing'"/>
    <authenticator :hide-sign-up="true">
      <router-view />
      <div class="sign_out">
        <amplify-sign-out v-if="$route.path != '/printing'"></amplify-sign-out>
      </div>
    </authenticator>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
    vertical-align: middle;
    display: table-cell;
    width: 100vw;
}
.sign_out{
  padding-left: 40%;
  padding-right: 40%;
  margin-top: 50px;
}

</style>

<script>
  import { onAuthUIStateChange } from '@aws-amplify/ui-components';
  // import { Auth } from 'aws-amplify';

  export default {
  name: 'App',
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
    });
    
  },
  data() {
    return {
      user: undefined,
      authState: undefined,
      unsubscribeAuth: undefined,
      current_path: this.$route.path,
      formFields: [
        { type: 'username' },
        { type: 'password' },
      ],
    };
  },
  // async mounted() {
  //   this.user = await Auth.currentAuthenticatedUser();
  // },
  beforeUnmount() {
    // this.unsubscribeAuth();

  },
};

</script>
